import { Action } from '../actions/ubi';

const defaultState = {
  isFetching: false,
  quoteUrl: undefined,
  errorType: undefined,
};

export default function ubiReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Ubi.FetchQuoteUrlPending:
      return {
        ...state,
        isFetching: true,
      };

    case Action.Ubi.FetchQuoteUrlCompleted:
      return {
        ...state,
        isFetching: false,
        quoteUrl: body.quoteUrl,
      };
    case Action.Ubi.FetchQuoteUrlFailed:
      return {
        ...state,
        isFetching: false,
        errorType: body.status === 410 ? 'ExpiredOffer' : 'Default',
      };

    default:
      return state;
  }
}
